import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'AvmColor',
    standalone: true,
})
export class AvmColorPipe implements PipeTransform {
    constructor() {}

    /**
     * Formate une date.
     * @param date : Date à formatter
     */
    transform(values: number[]): string {
        let labels = '';

        if (values) {
            values.forEach((x) => {
                if (labels.length > 0) {
                    labels += ', ';
                }

                switch (x) {
                    case 1:
                        labels += 'aucune';
                        break;
                    case 2:
                        labels += 'vert';
                        break;
                    case 3:
                        labels += 'orange';
                        break;
                    case 4:
                        labels += 'rouge';
                        break;
                    case 5:
                        labels += 'gris';
                        break;
                    case 6:
                        labels += 'bleu clair';
                        break;
                    case 7:
                        labels += 'bleu foncé';
                        break;
                }
            });
        }

        return labels;
    }
}
